// ThreeJS 기본 설정을 담당하는 클래스
class ThreeSetup {
  constructor(game) {
    this.game = game;
  }

  // ThreeJS 기본 설정
  async initialize() {
    Utils.log("ThreeJS 기본 설정 중...");

    this.setupRenderer();
    this.setupCamera();
    this.setupScene();

    // 윈도우 리사이즈 이벤트 등록
    window.addEventListener("resize", () => this.onWindowResize());

    Utils.log("ThreeJS 설정 완료");
  }

  // 렌더러 설정
  setupRenderer() {
    const config = GameConfig.RENDERER;

    this.game.renderer = new THREE.WebGLRenderer({
      antialias: config.ANTIALIAS,
    });

    this.game.renderer.setSize(window.innerWidth, window.innerHeight);
    this.game.renderer.shadowMap.enabled = true;
    this.game.renderer.shadowMap.type = config.SHADOW_MAP_TYPE;
    this.game.renderer.shadowMap.autoUpdate = true;
    this.game.renderer.outputColorSpace = config.OUTPUT_COLOR_SPACE;
    this.game.renderer.toneMapping = config.TONE_MAPPING;
    this.game.renderer.toneMappingExposure = config.TONE_MAPPING_EXPOSURE;

    document
      .getElementById("gameContainer")
      .appendChild(this.game.renderer.domElement);
  }

  // 카메라 설정
  setupCamera() {
    const config = GameConfig.CAMERA;
    const aspect = window.innerWidth / window.innerHeight;

    this.game.camera = new THREE.OrthographicCamera(
      -config.VIEW_SIZE * aspect,
      config.VIEW_SIZE * aspect,
      config.VIEW_SIZE,
      -config.VIEW_SIZE,
      config.NEAR,
      config.FAR
    );

    this.game.camera.position.set(
      config.POSITION.x,
      config.POSITION.y,
      config.POSITION.z
    );

    this.game.camera.lookAt(
      config.LOOK_AT.x,
      config.LOOK_AT.y,
      config.LOOK_AT.z
    );
  }

  // 씬 설정
  setupScene() {
    this.game.scene = new THREE.Scene();
    this.game.scene.background = new THREE.Color(
      GameConfig.SCENE.BACKGROUND_COLOR
    );
  }

  // 윈도우 리사이즈 처리
  onWindowResize() {
    const aspect = window.innerWidth / window.innerHeight;
    const viewSize = GameConfig.CAMERA.VIEW_SIZE;

    this.game.camera.left = -viewSize * aspect;
    this.game.camera.right = viewSize * aspect;
    this.game.camera.top = viewSize;
    this.game.camera.bottom = -viewSize;

    this.game.camera.updateProjectionMatrix();
    this.game.renderer.setSize(window.innerWidth, window.innerHeight);
  }
}

// webpack 빌드를 위해 default export 추가
export default ThreeSetup;